import React from 'react'
import PropTypes from 'prop-types'
import { GyptRecordsPageTemplate } from '../../templates/gypt-records-page'

const GyptRecordsPagePreview = ({ entry, widgetFor }) => (
  <GyptRecordsPageTemplate
    title={entry.getIn(['data', 'title'])}
    content={widgetFor('body')}
  />
)

GyptRecordsPagePreview.propTypes = {
  entry: PropTypes.shape({
    getIn: PropTypes.func,
  }),
  widgetFor: PropTypes.func,
}

export default GyptRecordsPagePreview
